import { render, staticRenderFns } from "./UserOneItem.vue?vue&type=template&id=157902c8&scoped=true&"
import script from "./UserOneItem.vue?vue&type=script&lang=ts&"
export * from "./UserOneItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserOneItem.vue?vue&type=style&index=0&id=157902c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157902c8",
  null
  
)

export default component.exports